import React from "react";
const PackageItem = ({ packageList, value, onSelect }) => {
  return (
    <div className="package-select">
      {Array.isArray(packageList) && packageList.map(
        (item, index) => (
          <div 
            key={index} 
            className={`box ${ item.id === value ? 'active': '' }`} 
            onClick={() => onSelect(item.id)}
          >
            <div>{ item.price }</div>
            <p>{ item.perUnit }</p>
          </div>
        ))}
    </div>
  );
};
export default PackageItem;
